module.exports = __webpack_public_path__ + "static/media/graduation.e1c117f2.png";